const getters = {
  selectedUser: state => {
    return state.selUser ? state.selUser : null
  },
}

export default getters
